import classNames from 'classnames';
import React, { FC } from 'react';

interface Props {
  page: number;
  active: boolean;
  onClick: () => void;
}

const PaginationCell: FC<Props> = ({ page, active, onClick }) => (
  <button className={classNames('pagination-cell', { active })} onClick={onClick}>
    <span className="page" aria-label={`Page ${page}`}>
      {page}
    </span>
  </button>
);

export default PaginationCell;
